import { GetDynamicFields } from "services/attendant"

export const getFields = async (clientId?: string) => {
  const fields = await GetDynamicFields(clientId);

  return fields;
}
